<template>
  <div class="space-y-4">
    <FormGroup
      label="Where did you work?"
      required
    >
      <div class="mb-4">
        <StateAutocomplete
          :initial-state="state"
          @update:selected="handleStateSelect"
          @update:input="handleStateInput"
        />
      </div>
      <CityAutocomplete
        ref="cityAutocompleteRef"
        :state-code="selectedState?.code"
        :state-name="selectedState?.label"
        :initial-city="city"
        :disabled="!state"
        @update:selected="handleCitySelect"
        @update:input="handleCityInput"
      />
    </FormGroup>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, watch } from 'vue'
import StateAutocomplete, {
  type StateOption
} from '~/components/company/filters/StateAutocomplete.vue'
import CityAutocomplete, {
  type City
} from '~/components/company/filters/CityAutocomplete.vue'
import { stateOptions } from '~/utils/states'

const props = defineProps<{
  state: string
  city: string
}>()
const emit = defineEmits<{
  'update:state': [value: string]
  'update:city': [value: string]
}>()
const findStateByCodeOrName = (stateValue: string): StateOption | null => {
  if (!stateValue) return null
  let state = stateOptions.find(s => s.code === stateValue)
  if (!state) {
    state = stateOptions.find(
      s => s.label.toLowerCase() === stateValue.toLowerCase()
    )
  }
  return state || null
}
const selectedState = ref<StateOption | null>(
  findStateByCodeOrName(props.state)
)
const cityAutocompleteRef = ref<InstanceType<typeof CityAutocomplete> | null>(
  null
)
function handleStateSelect(state: StateOption | null) {
  selectedState.value = state
  emit('update:state', state?.label || '')
  if (state?.label !== props.state) {
    emit('update:city', '')
  }
}
function handleStateInput(value: string) {
  if (!value) {
    selectedState.value = null
    emit('update:state', '')
    emit('update:city', '')
  }
}
watch(
  () => props.state,
  (newState) => {
    if (newState && !selectedState.value) {
      selectedState.value = findStateByCodeOrName(newState)
    }
  },
  { immediate: true }
)
function handleCitySelect(city: City | null) {
  emit('update:city', city?.name || '')
}
function handleCityInput(value: string) {
  if (!value) {
    emit('update:city', '')
  }
}
onMounted(() => {
  if (props.state && props.state.length === 2) {
    const stateObj = stateOptions.find(s => s.code === props.state)
    if (stateObj) {
      emit('update:state', stateObj.label)
    }
  }
  setTimeout(() => {
    if (cityAutocompleteRef.value && props.state) {
      (cityAutocompleteRef.value as any).triggerLoadCities()
    }
  }, 100)
})
</script>
